import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative h-screen w-full flex items-center justify-center overflow-hidden" data-id="element-78">
      {/* Background Image with Parallax effect */}
      <motion.div className="absolute inset-0 z-0" initial={{
      scale: 1.1
    }} animate={{
      scale: 1
    }} transition={{
      duration: 2,
      ease: 'easeOut'
    }} data-id="element-79">
        <div className="absolute inset-0 bg-background/60 z-10" data-id="element-80"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-background/20 via-transparent to-background z-10" data-id="element-81"></div>
        <img src="https://images.unsplash.com/photo-1519167758481-83f550bb49b3?q=80&w=2098&auto=format&fit=crop" alt="Luxury Event" className="w-full h-full object-cover opacity-60" data-id="element-82" />
      </motion.div>

      <div className="container relative z-20 mx-auto px-6 md:px-12 flex flex-col items-center text-center mt-20" data-id="element-83">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.2,
        ease: [0.16, 1, 0.3, 1]
      }} className="mb-6 flex items-center gap-4" data-id="element-84">
          <span className="w-12 h-[1px] bg-gold" data-id="element-85"></span>
          <span className="text-gold uppercase tracking-[0.3em] text-xs font-sans" data-id="element-86">
            Kyiv, Ukraine
          </span>
          <span className="w-12 h-[1px] bg-gold" data-id="element-87"></span>
        </motion.div>

        <motion.h1 className="text-5xl md:text-7xl lg:text-8xl font-serif leading-[1.1] text-balance max-w-5xl mx-auto" initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.4,
        ease: [0.16, 1, 0.3, 1]
      }} data-id="element-88">
          Ми створюємо моменти, <br data-id="element-89" />
          <span className="italic text-white/90" data-id="element-90">що тривають вічно</span>
        </motion.h1>

        <motion.p className="mt-8 text-lg md:text-xl text-ivory/70 font-sans max-w-2xl font-light" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.8
      }} data-id="element-91">
          Ексклюзивна агенція подій. Від концептуальних бренд-активацій до
          розкішних приватних свят.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 1
      }} className="mt-12" data-id="element-92">
          <a href="#contact" className="group relative inline-flex items-center justify-center px-10 py-4 overflow-hidden border border-gold/50 text-gold uppercase tracking-widest text-sm transition-all duration-500 hover:border-gold" data-id="element-93">
            <span className="absolute inset-0 w-0 bg-gold transition-all duration-[250ms] ease-out group-hover:w-full" data-id="element-94"></span>
            <span className="relative group-hover:text-background transition-colors duration-300" data-id="element-95">
              Обговорити подію
            </span>
          </a>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center gap-2" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} data-id="element-96">
        <span className="text-[10px] uppercase tracking-widest text-ivory/50 font-sans" data-id="element-97">
          Scroll
        </span>
        <div className="w-[1px] h-12 bg-white/20 relative overflow-hidden" data-id="element-98">
          <motion.div className="absolute top-0 left-0 w-full h-1/2 bg-gold" animate={{
          y: ['-100%', '200%']
        }} transition={{
          repeat: Infinity,
          duration: 1.5,
          ease: 'linear'
        }} data-id="element-99" />
        </div>
      </motion.div>
    </section>;
}